import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, BookOpen, Activity, Mail } from 'lucide-react';
import { Button } from '../ui/Button';
export function DeveloperSupport() {
  return <section className="py-20 bg-slate-50" data-id="element-204">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-205">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 sm:mb-12" data-id="element-206">
          <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-4" data-id="element-207">
            Developer Support
          </h2>
          <p className="text-lg text-slate-600" data-id="element-208">Get help when you need it.</p>
        </motion.div>

        <div className="max-w-4xl mx-auto" data-id="element-209">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-210">
            <motion.a href="#/docs" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="group bg-white border-2 border-blue-200 rounded-lg p-6 hover:border-blue-400 hover:shadow-lg transition-all text-center sm:text-left flex flex-col items-center sm:items-start" data-id="element-211">
              <BookOpen className="w-8 h-8 text-blue-600 mb-4" data-id="element-212" />
              <h3 className="text-lg font-semibold text-slate-900 mb-2 group-hover:text-blue-600 transition-colors" data-id="element-213">
                Documentation
              </h3>
              <p className="text-sm text-slate-600" data-id="element-214">
                Comprehensive guides, API reference, and tutorials
              </p>
            </motion.a>

            <motion.a href="#" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="group bg-white border border-slate-200 rounded-lg p-6 hover:border-blue-300 hover:shadow-md transition-all text-center sm:text-left flex flex-col items-center sm:items-start" data-id="element-215">
              <Activity className="w-8 h-8 text-green-600 mb-4" data-id="element-216" />
              <h3 className="text-lg font-semibold text-slate-900 mb-2 group-hover:text-green-600 transition-colors" data-id="element-217">
                API Status
              </h3>
              <p className="text-sm text-slate-600" data-id="element-218">
                Real-time system status and uptime monitoring
              </p>
            </motion.a>

            <motion.a href="#" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="group bg-white border border-slate-200 rounded-lg p-6 hover:border-blue-300 hover:shadow-md transition-all text-center sm:text-left flex flex-col items-center sm:items-start" data-id="element-219">
              <MessageCircle className="w-8 h-8 text-purple-600 mb-4" data-id="element-220" />
              <h3 className="text-lg font-semibold text-slate-900 mb-2 group-hover:text-purple-600 transition-colors" data-id="element-221">
                Changelog
              </h3>
              <p className="text-sm text-slate-600" data-id="element-222">
                Latest updates, new features, and improvements
              </p>
            </motion.a>

            <motion.a href="mailto:sales@obseq.xyz" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="group bg-white border border-slate-200 rounded-lg p-6 hover:border-blue-300 hover:shadow-md transition-all text-center sm:text-left flex flex-col items-center sm:items-start" data-id="element-223">
              <Mail className="w-8 h-8 text-orange-600 mb-4" data-id="element-224" />
              <h3 className="text-lg font-semibold text-slate-900 mb-2 group-hover:text-orange-600 transition-colors" data-id="element-225">
                Contact Sales
              </h3>
              <p className="text-sm text-slate-600" data-id="element-226">
                Talk to our team about enterprise solutions
              </p>
            </motion.a>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="bg-blue-50 border border-blue-200 rounded-lg p-8 text-center" data-id="element-227">
            <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-228">
              Need help getting started?
            </h3>
            <p className="text-slate-600 mb-6" data-id="element-229">
              Our team is here to help you integrate Obseq into your platform.
            </p>
            <a href="mailto:sales@obseq.xyz" data-id="element-230">
              <Button size="lg" data-id="element-231">Contact Developer Support</Button>
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}